import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import ring from "../../../../../Assets/images/create-ring.png";
import diamond from "../../../../../Assets/images/create-diamond.png";
import { BsArrowRight } from "react-icons/bs";

const DesignDiamondRing = () => {
  const settings = {
    customPaging: function (i) {
      return <a className="dots11">{i + 1}</a>;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="RingBuilderHome design-diamond-ring-section">
      <Container>
        <Row className="align-items-center">
          <Col md={12} xs={12}>
            <div className="textBox">
              <Heading className="text-center p-0">
                <span>Create Your Own</span>
                <h2>Diamond Ring</h2>
                {/* <div className="content mt-4">
                  <Link
                    to="/ringsettings"
                    className="btn outline-base-btn small mr-3"
                  >
                    Start with a setting
                  </Link>
                  <Link to="/diamonds" className="btn outline-base-btn small">
                    Start with a diamond{" "}
                  </Link>
                </div> */}
              </Heading>
              <div className="text-center">

                <p>
                  Select a setting and choose a diamond to create your own diamond engagement ring.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="dy_design_ring_inner_box">
              <Image src={ring} alt="ring" loading="lazy" className="img-fluid" />
              <h2>Start With A Setting</h2>
              <p>Search through our vast selection of AGS & GIA certified
                diamonds to find your perfect diamond.</p>
              <Link
                to="/ringsettings"
                className="btn outline-base-btn small dy_start_with_Setting_btn mr-3"
              >
              Select Settings<BsArrowRight className="ml-2"/>
              </Link>
            </div>
          </Col>
           <Col md={6} xs={12}>
            <div className="dy_design_ring_inner_box">
              <Image src={diamond} alt="ring" loading="lazy" className="img-fluid" />
              <h2>Start With A Diamond</h2>
              <p>Browse our assortment of unique
engagement ring settings.</p>
              <Link
                to="/ringsettings"
                className="btn outline-base-btn small dy_start_with_Setting_btn mr-3"
              >
             Select Diamond <BsArrowRight className="ml-2"/>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DesignDiamondRing;
